(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlider(slider) {
      if (!slider) return;
      if (slider.dataset.heroInitialized === 'true') return;

      var track = slider.querySelector('.hero-slider__track');
      if (!track) return;

      var dotsWrap = slider.querySelector('.hero-slider__dots');
      var prevBtn = slider.querySelector('.hero-slider__arrow--prev');
      var nextBtn = slider.querySelector('.hero-slider__arrow--next');
      var progressFill = slider.querySelector('.hero-slider__progress-fill');
      var slides = track.querySelectorAll('.hero-slider__slide:not(.hero-slider__slide--clone):not([hidden])');
      var total = slides.length;
      var current = 0;
      var timer = null;
      var autoplay = slider.dataset.autoplay === 'true';
      var delay = Math.max(parseInt(slider.dataset.delay, 10) || 3000, 3000);

      slider.dataset.heroInitialized = 'true';
      if (total <= 1) return;

      // Clone first slide for seamless loop if not cloned yet
      if (!track.querySelector('.hero-slider__slide--clone')) {
        var firstClone = slides[0].cloneNode(true);
        firstClone.classList.add('hero-slider__slide--clone');
        firstClone.removeAttribute('data-shopify-editor-block');
        track.appendChild(firstClone);
      }

      if (dotsWrap && dotsWrap.children.length === 0) {
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.className = 'hero-slider__dot' + (i === 0 ? ' is-active' : '');
          dot.type = 'button';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.setAttribute('aria-selected', String(i === 0));
          dot.addEventListener('click', function () {
            goTo(i);
            resetTimer();
          });
          dotsWrap.appendChild(dot);
        });
      }

      function goTo(idx) {
        if (current >= total && idx > current) {
          track.style.transition = 'none';
          current = 0;
          track.style.transform = 'translateX(0%)';
          track.offsetHeight;
          idx = 1;
        }

        if (idx < 0) {
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + total * 100 + '%)';
          track.offsetHeight;
          idx = total - 1;
        }

        if (idx > total) idx = 0;

        current = idx;
        track.style.transition = 'transform 600ms cubic-bezier(0.16, 1, 0.3, 1)';
        track.style.transform = 'translateX(-' + current * 100 + '%)';

        var dotIndex = current;
        if (dotIndex === total || dotIndex < 0) {
          dotIndex = 0;
        }

        var dots = dotsWrap ? dotsWrap.querySelectorAll('.hero-slider__dot') : [];
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === dotIndex);
          dot.setAttribute('aria-selected', String(i === dotIndex));
        });

        if (progressFill) {
          var maxIndex = Math.max(total - 1, 1);
          var progress = Math.min(dotIndex / maxIndex, 1);
          progressFill.style.transform = 'translateX(' + 200 * progress + 'px)';
        }
      }

      track.addEventListener('transitionend', function () {
        if (current === total) {
          track.style.transition = 'none';
          current = 0;
          track.style.transform = 'translateX(0%)';
          track.offsetHeight;
          track.style.transition = '';
        }
      });

      function next() {
        goTo(current + 1);
      }

      function prev() {
        goTo(current - 1);
      }

      function startTimer() {
        if (!autoplay) return;
        if (timer) clearInterval(timer);
        timer = setInterval(function () {
          next();
        }, delay);
      }

      function resetTimer() {
        if (timer) clearInterval(timer);
        startTimer();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
          resetTimer();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
          resetTimer();
        });
      }

      var startX = 0;
      slider.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
      }, { passive: true });

      slider.addEventListener('touchend', function (event) {
        var diff = startX - event.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            next();
          } else {
            prev();
          }
          resetTimer();
        }
      }, { passive: true });

      var isShopifyEditor = window.Shopify && Shopify.designMode;
      if (!isShopifyEditor) {
        slider.addEventListener('mouseenter', function () {
          if (timer) clearInterval(timer);
        });

        slider.addEventListener('mouseleave', function () {
          startTimer();
        });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          if (timer) clearInterval(timer);
        } else {
          resetTimer();
        }
      });

      goTo(0);
      startTimer();
    }

    window.__bohopanaInitHeroSlider = initHeroSlider;

    function initAllHeroSliders(root) {
      var scope = root || document;
      scope.querySelectorAll('.hero-slider').forEach(function(slider) {
        initHeroSlider(slider);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllHeroSliders(document);
      });
    } else {
      initAllHeroSliders(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var targetSlider = event.target.querySelector('.hero-slider');
      if (targetSlider) {
        targetSlider.dataset.heroInitialized = 'false';
        initHeroSlider(targetSlider);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
